var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodeActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u9A8C\u8BC1\u7801_current@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186FF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186FF0",
    stopOpacity: 0.75,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u63A7\\u4EF6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9A8C\\u8BC1\\u7801_current"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248",
    opacity: 0.100000001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,4 C16.5522847,4 17,4.44771525 17,5 L17,14.75 C17,15.3022847 16.5522847,15.75 16,15.75 L12.569246,15.75 C12.523935,15.75 12.4794759,15.7623145 12.4406221,15.7856268 L10.2572479,17.0956513 C10.0989067,17.190656 9.90109332,17.190656 9.74275212,17.0956513 L7.55937795,15.7856268 C7.5205241,15.7623145 7.476065,15.75 7.43075401,15.75 L4,15.75 C3.44771525,15.75 3,15.3022847 3,14.75 L3,5 C3,4.44771525 3.44771525,4 4,4 L16,4 Z M15.5,5.5 L4.5,5.5 L4.5,14.25 L7.43075401,14.25 C7.68449553,14.25 7.93442061,14.3051688 8.16349319,14.4107876 L8.33112158,14.4993874 L10,15.5 L11.6688784,14.4993874 C11.88646,14.3688384 12.1291531,14.2875599 12.3799216,14.2602704 L12.569246,14.25 L15.5,14.25 L15.5,5.5 Z M11.9194174,8.23743687 L12.6265242,8.94454365 C12.7241552,9.04217472 12.7241552,9.20046597 12.6265242,9.29809704 L9.79809704,12.1265242 C9.70046597,12.2241552 9.54217472,12.2241552 9.44454365,12.1265242 L7.6767767,10.3587572 C7.57914562,10.2611261 7.57914562,10.1028349 7.6767767,10.0052038 L8.38388348,9.29809704 C8.48151455,9.20046597 8.63980579,9.20046597 8.73743687,9.29809704 L9.62132034,10.1819805 L11.565864,8.23743687 C11.6634951,8.13980579 11.8217863,8.13980579 11.9194174,8.23743687 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeActive);
export default __webpack_public_path__ + "static/media/code-active.2a060bc82bffacc46e3d913c861e4611.svg";
export { ForwardRef as ReactComponent };